import React from 'react';
import { JourneyStep } from '../../types/journey';
import { useLanguage } from '../../context/LanguageContext';
import './DefinitionOfDoneModal.css';

interface DefinitionOfDoneModalProps {
  step: JourneyStep;
  isOpen: boolean;
  onClose: () => void;
}

export const DefinitionOfDoneModal: React.FC<DefinitionOfDoneModalProps> = ({
  step,
  isOpen,
  onClose
}) => {
  const { uiLanguage } = useLanguage();

  if (!isOpen) return null;

  // Calculate progress based on dodCriteria
  const totalCriteria = step.dodCriteria.length;
  const completedCriteria = 0; // TODO: Track completion in future enhancement
  const progressPercentage = totalCriteria > 0 ? (completedCriteria / totalCriteria) * 100 : 0;

  // Get translated content
  const stepTitle = uiLanguage === 'zh' && step.title_zh ? step.title_zh : step.title;
  const criteria = uiLanguage === 'zh' && step.dodCriteria_zh ? step.dodCriteria_zh : step.dodCriteria;

  return (
    <div className="dod-modal-overlay" onClick={onClose}>
      <div className="dod-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="dod-modal-header">
          <h2>Definition of Done</h2>
          <button
            className="dod-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className="dod-modal-body">
          <div className="dod-modal-step-info">
            <h3>{stepTitle}</h3>
            <p className="dod-modal-description">
              {uiLanguage === 'zh' && step.description_zh ? step.description_zh : step.description}
            </p>
          </div>

          <div className="dod-modal-progress">
            <div className="dod-modal-progress-bar">
              <div
                className="dod-modal-progress-fill"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <span className="dod-modal-progress-text">
              {completedCriteria} of {totalCriteria} completed
            </span>
          </div>

          <div className="dod-modal-criteria-list">
            <h4>Completion Criteria:</h4>
            {criteria.map((criterion, index) => (
              <div key={index} className="dod-modal-criterion">
                <label className="dod-modal-criterion-label">
                  <input
                    type="checkbox"
                    checked={false} // TODO: Track completion in future enhancement
                    readOnly
                    className="dod-modal-checkbox"
                  />
                  <span className="dod-modal-criterion-text">{criterion}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="dod-modal-footer">
          <button className="dod-modal-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
